import React, { useEffect } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { IsEnglish } from '../../../utils/language';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretRight, faSquarePollVertical, faLink } from "@fortawesome/free-solid-svg-icons"
import IconButton from '@material-ui/core/IconButton';
import * as keyMenu from '../../../scripts/KeyMenu';
import background_documents2 from "../../../images/survey.png";

const useStyles = makeStyles((theme) => ({
    divRootSurvey: {
        color: '#ffffff',
        height: '37px',
        '& > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
        fontVariant: 'all-petite-caps',
        fontSize: '18px'
    },
    divContent: {
        margin: '5px 5px',
        padding: '4px 10px',
        textAlign: 'left',
        color: '#ffffff',
        '& > div > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
        '& > span': {
            display: 'table'
        },
    },
    title: {
    },
    divFooter: {
        textAlign: 'center',
        '& > svg': {
            margin: '0px 10px 0px 0px'
        }
    },
    linkGoIcon: {
        fontSize: '16px !important',
        padding: 'unset'
    },
    divBodySurvey: {
        height: '205px',
        overflow: 'auto',
        borderRadius: '8px',
        marginTop: '4px'
    },
    spanNoContent: {
        textAlign: 'center',
        display: 'table',
        width: '100%',
        marginTop: '10px',
    },
    surveyImg: {
        width: '35px',
        position: 'relative',
        float: 'left'
    },
    surveyTitle: {
        verticalAlign: 'middle',
        marginLeft: '10px',
        fontVariant: 'all-petite-caps',
        fontSize: '18px'
    }
}));

function Survey(props) {
    const classes = useStyles();

    const [data, setData] = React.useState(null);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined && props.data.length > 0) {
            loadSurvey();
        }
    }, [props.data]);

    const loadSurvey = () => {
        setData(props.data);
    }

    const handleSelectedPage = () => {
        props.handleSelectedPage(keyMenu.MENU_SURVEY);
    }

    return (
        <>
            <div className={classes.divRootSurvey}>
                <img className={classes.surveyImg} src={background_documents2} />
                <span className={classes.surveyTitle}>{i18next.t('home:homeContent.pendingSurvey')}</span>
            </div>
            <div className={classes.divBodySurvey}>
                {data && data.map((obj, index) =>
                    <div className={classes.divContent} key={index}>
                        <div>
                            <FontAwesomeIcon icon={faCaretRight} className="fa-w-16" />
                            <span className={classes.title}>{obj.surveyExerciseCode} - {IsEnglish() ? obj.descriptionE : obj.descriptionF}</span>
                        </div>
                    </div>
                )}
                {(data === null) && <span className={classes.spanNoContent}>{i18next.t("home:homeContent.noSurvey")}</span>}
            </div>
            <div className={classes.divFooter}>
                <IconButton className={classes.linkGoIcon} edge="start" color="inherit" onClick={handleSelectedPage} aria-label="close">
                    <FontAwesomeIcon icon={faLink} className="fa-w-16" />
                    <span className={classes.linkGo}>{i18next.t('home:homeContent.goLink')}</span>
                </IconButton>
            </div>
        </>
    );
}
export default withNamespaces(['HomeContent'], { wait: true })(Survey);